<template>
  <div class="header">
    <div class="container">
      <img class="logo" src="@/assets/img/idco.png" alt="logo">
      <span class="title">深圳市艾迪科物联网技术有限公司</span>
      <div class="navbar" :class="{'hide': !showNavBar}">
        <ul class="nav-list">
          <li class="nav-item" @click="menuRoute(menu.path)" v-for="menu in menuList" :key="menu.path">
            <span class="nav-item-text" :class="{active: activeMenu == menu.path}">{{menu.name}}</span>
          </li>
          <!-- <li class="nav-item" @click="activeMenu = 'home'">
            <router-link to="/solution" class="nav-item-text" :class="{active: activeMenu == 'solution'}">解决方案</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/deploy" class="nav-item-text" :class="{active: activeMenu == 'deploy'}">企业部署</router-link>
          </li>
          <li class="nav-item"><router-link to="/service" class="nav-item-text" :class="{active: activeMenu == 'service'}">演示</router-link></li>
          <li class="nav-item">
            <router-link to="/about" class="nav-item-text" :class="{active: activeMenu == 'about'}">关于我们</router-link>
          </li>
          <li class="nav-item"><router-link to="/news" class="nav-item-text" :class="{active: activeMenu == 'news'}">新闻中心</router-link></li>
          <li class="nav-item">加入我们</li> -->
        </ul>
      </div>
      <div class="nav-btn" @click="showNav">
        <v-icon class="icon-bars" name="bars"/>
      </div>
    </div>
    <!-- <ul class="nav-title">
      <li>
          <router-link to="/" class="nav-item-text">首页</router-link>
      </li>
      <li>
          <router-link to="/solution" class="nav-item-text">解决方案</router-link>
        </li>
        <li>企业部署</li>
        <li>文档</li>
        <li><router-link to="/service" class="nav-item-text">演示</router-link></li>
        <li>
          <router-link to="/about" class="nav-item-text">关于我们</router-link>
        </li>
        <li><router-link to="/news" class="nav-item-text">新闻中心</router-link></li>
      </ul> -->
  </div>
</template>

<script>
import eventBus from '../eventbus'
export default {
  name: 'Header',
  data() {
    return {
      showNavBar: true,
      activeMenu: '/',
      menuList: [
        {
          name: '首页',
          path: '/'
        },
        {
          name: '解决方案',
          path: '/solution'
        },
        {
          name: '平台价值',
          path: '/deploy'
        },
        {
          name: '演示',
          path: '/service'
        },
        {
          name: '关于我们',
          path: '/about'
        },
        {
          name: '新闻中心',
          path: '/news'
        },
        // {
        //   name: '关于我们',
        //   path: '/'
        // }
      ]
    }
  },
  methods: {
    showNav() {
      this.showNavBar = !this.showNavBar
    },
    menuRoute(path) {
      if (this.activeMenu == path && this.$route.path == path) {
        return
      }
      this.activeMenu = path
      this.$router.replace(path)
    },
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  mounted() {
    if (this.isMobile()) { 
      this.showNavBar = false
    }
    eventBus.$on('onRoute', (() => {
      this.showNavBar = false
    }).bind(this))
    let self = this
    window.addEventListener('load', function () {
      if(location.href.split('#')[1] !== '/'){
        let path = location.href.split('#')[1]
        self.activeMenu = path
      }
    })
  },
  watch: {
    // 判断是不是通过点击箭头跳页的
    '$route.path' () {
      if (this.$route.query.mark === 1) {
        this.menuList.forEach(item => {
          if (item.path === this.$route.path) {
            this.activeMenu = this.$route.path
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/color";
$header-height: 70px;

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  height: $header-height;
  background: $background-color;
  box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.06);
}

.container {
  padding-top: 15px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 auto;
  width: 1140px;
  background: $background-color;

  @media (max-width: 1140px) {
    width: 100%;
  }

  .title {
    font-weight: bold;
  }

  @media (max-width: 866px) {
    width: 100%;
    // max-width: 620px;768px
    justify-content: space-between;
    .logo {
      margin-left: 15px;
    }

    .nav-btn {
      margin-right: 15px;
    }

    & > .hide {
      display: none;
    }

    .navbar {
      position: fixed;
      top: $header-height;
      width: 100%;
      z-index: 999;
      background-color: $background-color;
      box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.06);

      .nav-list {
        width: 100%;
        padding: 0;

        .nav-item {
          display: block;
          width: 100%;
          padding: 0;
          margin: 10px 0;
        }
      }
    }

    .nav-btn {
      display: block;
      &:hover {
        .nav-title {
          display: block;
        }
      }
    }
  }

  @media (max-width: 576px) {
    max-width: 540px;
    justify-content: space-between;
    
    .title {
      display: none;
    }
  }
}

.logo {
  width: 83px;
  height: 20px;
}

.navbar {
  display: flex;
  justify-content: flex-start;
  width: 768px;

  @media (max-width: 1140px) {
    width: auto;
  }

  & > .nav-list {
    list-style: none;

    & > .nav-item {
      display: inline-block;
      margin-left: 14px;
      margin-right: 14px;
      font-weight: bold;
      color: $nav-color;
      cursor: pointer;

      & > .nav-item-text {
        text-decoration: none;
        color: #4a6f8a;

        &.active {
          color: $nav-hover-color;
        }

        &:hover {
          color: $nav-hover-color;
        }
      }
      &:hover {
        color: $nav-hover-color;
      }
    }
  }
}

.nav-btn {
  display: none;
  border: 1px solid #44ce6f;
  padding: 4px 12px;
  .icon-bars {
    color: #44ce6f;
  }
}

.nav-title {
  width: 100%;
  padding: 10px 0px;
  box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.06);
  background-color: $background-color;
  li {
    margin-bottom: 12px;
    font-weight: bold;
    color: $nav-color;
    cursor: pointer;
    list-style-type: none;
    & > .nav-item-text {
      text-decoration: none;
      color: #4a6f8a;
      &:hover {
        color: $nav-hover-color;
      }
    }
  }
}
</style>